import type { RouterConfig } from '@nuxt/schema'
import type { RouteRecordRaw } from 'vue-router'

export default {
    routes(routes) {
        return routes.flatMap((route): RouteRecordRaw[] => {
            if (!route.path.endsWith('/profile/contracts')) {
                return [route]
            }

            // Reuse Nuxt's mode-aware path so saved listing URLs redirect without page components.
            const legacyRoutes = ['memberships', 'bookings', 'passes'].map(
                (page): RouteRecordRaw => {
                    return {
                        path: route.path.replace(/\/contracts$/, `/${page}`),
                        redirect(to) {
                            return {
                                path: to.path.replace(
                                    /\/(memberships|bookings|passes)\/?$/i,
                                    '/contracts'
                                ),
                                query: to.query,
                                hash: to.hash,
                                replace: true
                            }
                        }
                    }
                }
            )

            return [route, ...legacyRoutes]
        })
    }
} satisfies RouterConfig
